module.exports = __webpack_public_path__ + "img/paylah.5e412439.png";